import api from './api';

export function getTwilioToken() {
  return api.get('/voip/v2/token/');
}

export function getConference(id) {
  return api.get(`/voip/v2/conferences/?call_sid=${id}`);
}

export function getConferencesMissed(limit, offset) {
  return api.get(
    `/voip/v2/conferences/missed/?processed=false&ordering=-created_at&limit=${limit}&offset=${offset}`
  );
}

export function getMyRecentConferences(limit, offset) {
  return api.get(
    `/voip/v2/conferences/?mine=true&processed=true&limit=${limit}&offset=${offset}&ordering=-created_at`
  );
}

export function deleteConferenceMissed(id) {
  return api.put(`/voip/v2/conferences/missed/${id}/`, {
    processed: true,
  });
}

export function call(usernames, type) {
  return api.post('/voip/v2/call/', {
    recipients: usernames,
    type,
  });
}
